import { render, staticRenderFns } from "./EditDashboardPage.vue?vue&type=template&id=f405e126&"
import script from "./EditDashboardPage.vue?vue&type=script&lang=js&"
export * from "./EditDashboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports